import React from 'react';
import { Input } from 'reactstrap';
import MaskedInput from 'react-text-mask';


const TextBoxControl = (props) => {
  let {labelText, value, onChange, name, type, step, disabled, validationMessages, visible, showLabel, fieldType} = props;
  let isValid = !validationMessages || (validationMessages && (validationMessages[`${name}`] === '' || validationMessages[`${name}`] === undefined));
  let isVisible = visible === undefined ? true : visible;
  let isLabelVisible = showLabel === undefined ? true : showLabel;

  return isVisible ? (
    <div className="form-group row">
      {isLabelVisible && <label className="col-md-2 col-xs-3 col-sm-3 form-control-label" htmlFor={name}>{labelText}</label>}
      <div className="col-md-8 col-xs-10 col-sm-10 ">
        {/* <InputType /> */}
        {
          fieldType === "abn" ?
          <MaskedInput
                  mask={[/\d/, /\d/,' ',/\d/, /\d/, /\d/,' ',/\d/, /\d/, /\d/,' ',/\d/, /\d/, /\d/]}
                  className={'form-control'}
                  value={value == null ? '' : value}
                  onChange={onChange}
                  name={name}
                  placeholder={labelText}
                  disabled={disabled}
                  guide={false}
            />
            :
            <Input type={type ? type : 'text'}
              className={'form-control'}
              value={value == null ? '' : value}
              onChange={onChange}
              name={name}
              placeholder={labelText}
              step={step}
              disabled={disabled}
            />
        }
        
        { !isValid && <div style={{color: 'red'}}>{validationMessages[`${name}`]}</div> }
      </div>
    </div>
  ) : null;
};

export default TextBoxControl;